import React from "react";
import "./index.css";

const HeadingComponent = (props) => {
  const { text } = props;
  return <h2 className="important-heading">{text}</h2>;
};

export default HeadingComponent;
